<template>
  <section
    id="get-in-touch"
    class="overflow-hidden"
  >
    <v-row
      class="primary white--text"
      no-gutters
    >
      <v-col
        class="hidden-sm-and-down"
        md="6"
      >
        <v-img
          :src="require('@/assets/contact.png')"
          height="100%"
        />
      </v-col>

      <v-col
        class="pa-5"
        cols="12"
        md="6"
      >
        <base-bubble-1 />

        <base-heading class="mb-5">
          Get In Touch
        </base-heading>
        <br>
        <v-sheet
          color="transparent"
          max-width="600"
        >
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <base-text
            class="mb-5 white--text"
            v-text="item.text"
            >
            </base-text>
          </v-list-item-content>
        </v-list-item>
        </v-sheet>
      </v-col>
    </v-row>
  </section>
</template>

<script>
  export default {
    name: 'GetInTouch',
    data: () => ({
      selectedItem: 1,
      items: [
        { text: 'No. 24/3, Aluvihare, Matale, Sri Lanka', icon: 'mdi-map-marker' },
        { text: '(+94) 766 545982', icon: 'mdi-phone' },
        { text: 'giwanthawijekoon@gmail.com', icon: 'mdi-email' },
      ],
    }),
  }
</script>
